import React from 'react';
import { connect } from 'react-redux';
import { Overlay, Popover } from 'react-bootstrap';

import { getColor } from 'helpers/charts';
import { getTextColor } from 'components/forms/autocomplete/Color';
import generateId from 'helpers/id';

import IntlDateTime from 'components/layout/IntlDateTime';

import DefaultPopover from 'components/layout/calendar/detailsPopover/Default';
import LeadPopover from 'components/layout/calendar/detailsPopover/Lead';

class CalendarWeekEvent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
      pickerId: generateId('cal-details-'),
      placement: 'right',
    };

    this.containerRef = React.createRef();
  }

  componentDidMount = () => {
    this.updatePlacement();
  };

  componentDidUpdate = prevProps => {
    const { width } = this.props;

    if (prevProps.width !== width) {
      this.updatePlacement();
    }
  };

  updatePlacement = () => {
    const { width } = this.props;

    if (this.containerRef && this.containerRef.current) {
      const bb = this.containerRef.current.getBoundingClientRect();

      if (bb.left + bb.width / 2 > width / 2) {
        this.setState({ placement: 'left' });
      } else {
        this.setState({ placement: 'right' });
      }
    }
  };

  showDetails = () => {
    this.setState({ showDetails: true });
  };

  closeDetails = () => {
    this.setState({ showDetails: false });
  };

  render() {
    const { style: propsStyle, appt } = this.props;
    const { showDetails, placement, pickerId } = this.state;

    let DetailsComponent = DefaultPopover;
    const style = { ...propsStyle };

    if (appt.type === 'lead') {
      DetailsComponent = LeadPopover;

      style.backgroundColor = '#' + getColor(appt.color || 1, 81);
      style.color = getTextColor(style.backgroundColor);
    }

    return (
      <>
        <div
          style={style}
          className="event-container bg-success-lighter cursor"
          ref={this.containerRef}
          onClick={this.showDetails}
        >
          <div className="event-inner">
            <div className="event-title">{appt.name}</div>
            {!appt.takes_full_day && (
              <div className="time-wrap">
                <span className="event-start-time">
                  <IntlDateTime date={appt.date_from} />
                </span>
                {' - '}
                <span className="event-end-time">
                  <IntlDateTime date={appt.date_to} />
                </span>
              </div>
            )}
          </div>
        </div>

        <Overlay
          show={showDetails}
          target={this.containerRef.current}
          placement={placement}
          rootClose
          onHide={this.closeDetails}
        >
          <Popover id={pickerId} style={{ maxWidth: 'none', zIndex: 1200 }}>
            <DetailsComponent appt={appt} />
          </Popover>
        </Overlay>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    width: state.layout.width,
  };
};

export default connect(mapStateToProps)(CalendarWeekEvent);
